import classes from "../../../../src/style/blog.css";
import * as React from 'react';
export default {
  classes,
  React
};